export const PRICE = '$13.99'
export const TOTAL_VALUE = '$362.00'
export const CTA_TEXT = 'SÍ, QUIERO ACCESO INSTANTÁNEO POR $13.99'
export const CTA_SUBTEXT = 'Acceso inmediato incluso si son las 3:00 AM.'

export interface OfferItem {
  tag: string
  title: string
  value: string
  description: string
  image?: string
  highlight?: boolean
}

export const offerItems: OfferItem[] = [
  {
    tag: 'EBOOK MAESTRO',
    title: 'PROMPT LABS',
    value: '$97',
    description:
      'El Manual de Campo para configurar el ADN de tu negocio en la IA y ejecutar cualquier idea en minutos.',
    image:
      'https://cdn.magicpatterns.com/uploads/5Q9RfJNAqY4CyZrnPn4qcW/mk-principal.png',
    highlight: true,
  },
  {
    tag: 'BONUS 1',
    title: 'El Arquitecto de Productos',
    value: '$47',
    description:
      'Deja de adivinar qué vender. Crea ofertas irresistibles y bonos que el mercado desee comprar.',
    image:
      'https://cdn.magicpatterns.com/uploads/v1d1Z5BytL3bpKzT5kjP24/BN-1.png',
  },
  {
    tag: 'BONUS 2',
    title: 'Nano Banana Realism',
    value: '$87',
    description:
      'El manual técnico para crear imágenes que engañan al ojo humano. Fotografía profesional sin cámara.',
    image:
      'https://cdn.magicpatterns.com/uploads/sA5mzscE6Yh2VEcEWoHzCS/BN_2.png',
  },
  {
    tag: 'BONUS 3',
    title: 'La Bóveda de Ganchos Universal',
    value: '$37',
    description:
      '100+ fórmulas para detener el scroll y obligar a tu cliente a prestarte atención.',
    image:
      'https://cdn.magicpatterns.com/uploads/pB4r81FVtHKYR8XRcZ3DaA/BN-3.png',
  },
  {
    tag: 'BONUS 4',
    title: 'AI Persuasion Frameworks',
    value: '$67',
    description:
      'Estructuras psicológicas (PAS, AIDA) aplicadas a la IA para vender sin esfuerzo.',
    image:
      'https://cdn.magicpatterns.com/uploads/6geG8L5V465RbmCZkpJzG4/BN-4.png',
  },
  {
    tag: 'BONUS 5',
    title: 'Tabla de Ángulos Psicológicos',
    value: '$27',
    description:
      'El secreto para no sonar nunca igual a tu competencia y rotar tu mensaje infinitamente.',
    image:
      'https://cdn.magicpatterns.com/uploads/bckVHAQ5VkFGEynkobHYtR/BN-5.png',
  },
]

export interface FaqItem {
  question: string
  answer: string
}

export const faqItems: FaqItem[] = [
  {
    question: '¿Esto funciona para mi nicho específico?',
    answer:
      'Totalmente. El sistema es "Agnóstico". Ya seas coach, dueño de ecommerce o freelancer, los prompts están diseñados con variables para que los adaptes a tu realidad en segundos.',
  },
  {
    question: '¿Necesito pagar suscripciones caras de IA?',
    answer:
      'No. Puedes aplicar el 90% de este manual con las versiones gratuitas de las herramientas líderes.',
  },
  {
    question: '¿Qué pasa si no tengo experiencia técnica?',
    answer:
      'PROMPT LABS está diseñado para personas que odian la tecnología. Si sabes copiar y pegar, sabes usar este sistema.',
  },
  {
    question: '¿Cómo y cuándo recibo el acceso?',
    answer:
      'De inmediato. Apenas se confirma tu pago recibes el acceso completo en tu correo, incluso si son las 3:00 AM. No esperas a nadie ni a ningún horario: descargas todo y empiezas a ejecutar hoy mismo.',
  },
  {
    question: '¿El pago es único o es una suscripción?',
    answer:
      'Es un único pago. Sin cargos recurrentes ni letra pequeña. Obtienes acceso de por vida a PROMPT LABS y a todos los bonos, con las actualizaciones futuras incluidas sin costo adicional.',
  },
]

export interface Testimonial {
  name: string
  role: string
  initials: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Andrea Salinas',
    role: 'Coach de negocios',
    initials: 'AS',
    quote:
      'Lancé mi nueva oferta en 2 días. Antes me quedaba semanas atascada frente a la pantalla en blanco. Ahora la IA estructura todo por mí y solo ejecuto.',
  },
  {
    name: 'Diego Fuentes',
    role: 'Dueño de ecommerce',
    initials: 'DF',
    quote:
      'Las imágenes de Nano Banana Realism parecen sesiones de fotos de $3,000. Dejé de pagar bancos de imágenes y mis anuncios por fin frenan el scroll.',
  },
  {
    name: 'Valeria Restrepo',
    role: 'Freelancer de marketing',
    initials: 'VR',
    quote:
      'Mis copys ahora venden solos. El sistema de "Llenado de Espacios" hizo que escribir un anuncio pase de 4 horas a 5 minutos. Cambio total.',
  },
  {
    name: 'Martín Ovalle',
    role: 'Agencia de publicidad',
    initials: 'MO',
    quote:
      'Escalé sin contratar a nadie. Lo que antes hacía un equipo completo, hoy lo materializo solo con PROMPT LABS. La velocidad de ejecución es brutal.',
  },
  {
    name: 'Camila Bravo',
    role: 'Creadora de contenido',
    initials: 'CB',
    quote:
      'Pensé que era "otro curso de IA" y me equivoqué. Es un manual de ingeniería real. En la primera tarde ya había creado mi primer activo digital.',
  },
  {
    name: 'Sebastián Lira',
    role: 'Taller mecánico',
    initials: 'SL',
    quote:
      'Soy de los que odian la tecnología y aun así lo uso todos los días. Copiar, pegar, adaptar. Mis anuncios locales nunca habían generado tantas citas.',
  },
]
